import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { laApplicationClassConfig } from './LaApplicationClass.name';

/** LA申請種別のENUM */
enum LaApplicationClass {
  laStartRegistration = 'LA011',
  laStartRegistrationCancel = 'LA012',
  laCancelBeforeMaturity = 'LA071',
  laCancelBeforeMaturityCancel = 'LA072',
  laContractInfoChange = 'LA081',
  laContractInfoChangeCancel = 'LA082',
  laArticleInfoChange = 'LA101',
  laArticleInfoChangeCancel = 'LA102',
  reLeaseAndContractExpired = 'LA121',
  reLeaseAndContractExpiredCancel = 'LA122',
}

const laApplicationClassMap = new Map([
  ['LA011', LaApplicationClass.laStartRegistration],
  ['LA012', LaApplicationClass.laStartRegistrationCancel],
  ['LA071', LaApplicationClass.laCancelBeforeMaturity],
  ['LA072', LaApplicationClass.laCancelBeforeMaturityCancel],
  ['LA081', LaApplicationClass.laContractInfoChange],
  ['LA082', LaApplicationClass.laContractInfoChangeCancel],
  ['LA101', LaApplicationClass.laArticleInfoChange],
  ['LA102', LaApplicationClass.laArticleInfoChangeCancel],
  ['LA121', LaApplicationClass.reLeaseAndContractExpired],
  ['LA122', LaApplicationClass.reLeaseAndContractExpiredCancel],
]);

const rawValueToLaApplicationClass = rawValueToEnumWithDefault(
  laApplicationClassMap,
  LaApplicationClass.laStartRegistration,
);

const laApplicationClassToDisplay = enumToNameWithDefault(LaApplicationClass, laApplicationClassConfig);

const laApplicationClassToDisplayWithPrefix = enumToNameWithDefault(
  LaApplicationClass,
  laApplicationClassConfig,
  true,
);

export {
  LaApplicationClass,
  laApplicationClassToDisplay,
  laApplicationClassToDisplayWithPrefix,
  rawValueToLaApplicationClass,
};
